module.exports = __webpack_public_path__ + "img/dalou_1_3@2x.dbe7b22b.png";